module.exports = __webpack_public_path__ + "static/media/GuidedBreathingActivity.11a345f7.mp3";